import React from 'react';

import { theme } from 'antd';

import { StatusTag } from '@components/StatusTag';

import { operatorSeverity } from '../../services';

interface IProps {
  severity?: string | null;
  text?: string | null;
}

export const OperatorStatus: React.FC<IProps> = ({ severity, text }) => {
  const { token } = theme.useToken();
  if (!text) return null;
  const colors = {
    error: token.colorError,
    warning: token.colorWarning,
    success: token.colorSuccess,
    info: token.colorPrimary,
  };
  return <StatusTag small color={colors[operatorSeverity(severity)]} name={text} />;
};
